import { PublicEvents } from "../types/Events.types";
import { processEvent } from "../services/processEvent.service";
;
/**
 * Analytics Api: externalVideoEvent.
 * @param {object} ExternalVideoEventParams Object with the external video event details.
 * @param {string} ExternalVideoEventParams.lineOfBusiness Line of Business of the video,
 * @param {string} ExternalVideoEventParams.videoName Name of the video
 * @param {string} ExternalVideoEventParams.videoStep Additional data point located within the event target
 * @param {string} ExternalVideoEventParams.videoType Type of video, including file format
 * @param {string} ExternalVideoEventParams.videoTitle Title of the video, can also be the page title
 * @param {object} [customPayload] An optional payload that may be provided to send additional data with the event.
 *
 * @example
 * import { externalVideoEvent } from "@octagon/public-analytics";
 *
 * // With NO additional payload data
 * externalVideoEvent({
 *   lineOfBusiness: "rb",
 * 	 videoName: "demo_olb_enroll",
 * 	 videoStep: "PLA",
 * 	 videoType: "video/mp4",
 * 	 videoTitle: "Chase Online Banking",
 * });
 *
 * // With additional payload data
 * externalVideoEvent(
 *   {
 *   	lineOfBusiness: "rb",
 * 	 	videoName: "demo_olb_enroll",
 * 	 	videoStep: "PLA",
 * 	 	videoType: "video/mp4",
 * 	 	videoTitle: "Chase Online Banking",
 *   },
 *   { devSpecifiedData: "1625254612928" }
 * );
 *
 *
 * @category Events
 */
export function externalVideoEvent(params, customPayload) {
    if (customPayload === void 0) { customPayload = {}; }
    processEvent(PublicEvents.EXTERNAL_VIDEO, params, customPayload);
}
